import React from 'react';
import '../../styles/Loading.css';

interface LoadingScreenProps {
  message?: string;
}

/**
 * Loading screen component shown during authentication and data loading
 */
const LoadingScreen: React.FC<LoadingScreenProps> = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p className="loading-message">{message}</p>
    </div>
  );
};

export default LoadingScreen;
